import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RestApiService } from '../service/restapi.service';
import { START_LESSON_URL, START_LESSON_BY_TOKEN_URL } from '../constants/ApiURLConst';
import { ApiResponse } from '../model/apiresponse';

declare var JitsiMeetExternalAPI: any;

@Component({
  selector: 'app-lesson',
  templateUrl: './lesson.component.html',
  styleUrls: ['./lesson.component.css'],
})
export class LessonComponent implements OnInit {
  public lessonInvitationId: string;
  public token: string;
  public api: any;
  public lessonStatus: string;
  public lessonStartTime: number;
  public lessonEndTime: number;
  public lessonTitle: string;
  public hideVirtualBackgroundBtn:Boolean;
  public jitsiParam: any = {
    userInfo: {},
  };

  // For Custom Controls
  isAudioMuted = false;
  isVideoMuted = false;
  isDictionary = false;
  showMetronome = false;
  selectedBPM: number = 150;
  volume: number = 50;
  isPlaying = false;
  showCalculator = false;
  showPeriodicTable = false;
  isMenuOpen = false;
  metronomeSoundInterval = null;
  
  @ViewChild('metroNomeAudioElem') audioElement!: ElementRef<HTMLAudioElement>;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private restApi: RestApiService
  ) {}

  ngOnInit(): void {
    this.checkisSafari();
    this.route.queryParams.subscribe((params) => {
      this.lessonInvitationId = params.lessonInvitationId;
      this.token = params.token;
    });
    this.getLessonStatus();
  }

  toggleDropdown() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  initVideo(): void {
    const options = {
      roomName: this.jitsiParam.roomName,
      width: '100%',
      height: '100%',
      parentNode: document.querySelector('#videoDiv'),
      jwt: this.jitsiParam.jwt,

      userInfo: this.jitsiParam.userInfo,
      configOverwrite: {
        toolbarButtons: [],                 // removes toolbar forever
        prejoinPageEnabled: false,
        disableInviteFunctions: true,
        disableProfile: true,
        disableModeratorIndicator: true,
        disableReactions: true,
      },

      interfaceConfigOverwrite: {
        TOOLBAR_ALWAYS_VISIBLE: false,
        SHOW_JITSI_WATERMARK: false,
        SHOW_BRAND_WATERMARK: false,
        HIDE_INVITE_MORE_HEADER: true,
      }
    };

    this.api = new JitsiMeetExternalAPI(this.jitsiParam.domain, options);

    this.api.executeCommand('subject', this.lessonTitle);
  }

  toggleCamera(): void {
    var currDevice = this.api.getCurrentDevices();
    var allDevices = this.api.getAvailableDevices();
    var currDeviceId = null;

    currDevice.then((data: any) => {
      var videoDevices = data.videoInput;
      currDeviceId = videoDevices.deviceId;

      allDevices.then((data: any) => {
        var videoDevices = data.videoInput;
        for (let i = 0; i < videoDevices.length; i++) {
          if (currDeviceId != videoDevices[i].deviceId) {
            this.api.setVideoInputDevice(
              videoDevices[i].label,
              videoDevices[i].deviceId
            );
          }
        }
      });
    });
  }

  endCall(): void {
    this.executeCommand('hangup');
    window.parent.close();
  }

  getParticipants() {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(this.api.getParticipantsInfo()); // get all participants
      }, 500);
    });
  }

  executeCommand(command: string): void {
    this.api.executeCommand(command);
    if (command == 'hangup') {
      window.parent.close();
    }

    if (command == 'toggleAudio') {
      this.isAudioMuted = !this.isAudioMuted;
    }

    if (command == 'toggleVideo') {
      this.isVideoMuted = !this.isVideoMuted;
    }
  }

  getLessonStatus(): void {
    const url = this.token ? START_LESSON_BY_TOKEN_URL : START_LESSON_URL;
    const body = this.token
      ? JSON.stringify({ token: this.token })
      : JSON.stringify({ lessonInvitationId: this.lessonInvitationId });
    this.restApi.postItem(url, body, (response: ApiResponse) => {
      var responseObj = response.responseObject;
      console.log(response.responseObject);
      this.lessonStatus = responseObj.lessonStatus;
      this.lessonStartTime = responseObj.lessonStartTime;
      this.lessonEndTime = responseObj.lessonEndTime;
      this.jitsiParam = responseObj.jitsiParams || this.jitsiParam;
      this.lessonTitle = responseObj.lessonTitle;
      if (this.lessonStatus == 'STARTED') {
        console.log(this.jitsiParam);
        this.initVideo();
      }
    });
  }

  timerFinished(): void {
    location.reload();
  }

  openWhieBoard(): void {
    const queryParams = this.token
      ? { token: this.token }
      : { lessonInvitationId: this.lessonInvitationId };
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/whiteboard'], { queryParams })
    );
    window.open(url, '_blank');
  }

  toggleVirtualBackground():void{
    this.api.executeCommand('toggleVirtualBackgroundDialog');
  }

  checkisSafari():void{
    const ua = navigator.userAgent.toLowerCase();

    const isChrome =
      ua.includes('chrome') &&
      !ua.includes('edge') &&
      !ua.includes('edg') &&
      !ua.includes('opr') &&
      !ua.includes('brave');

    this.hideVirtualBackgroundBtn = isChrome;
  }

  toggleDictionary(): void {
    this.isMenuOpen = false;
    this.isDictionary = !this.isDictionary;
  }

  toggleMetronome(): void {
    this.isMenuOpen = false;
    this.showMetronome = !this.showMetronome;
  }

  toggleCalculator(): void {
    this.isMenuOpen = false;
    this.showCalculator = !this.showCalculator;
  }
  
  togglePeriodicTable(): void {
    this.isMenuOpen = false;
    this.showPeriodicTable = !this.showPeriodicTable;
  }

  playMetronome(): void {
    this.isPlaying = true;
    this.playMetronomeSound();
  }

  pauseMetronome(): void {
    this.isPlaying = false;
    clearInterval(this.metronomeSoundInterval);
  }

  updateBpmDisplay(event: any): void {
    this.selectedBPM = event.target.value;
    if (this.isPlaying) {
      this.playMetronomeSound();
    }
  }

  changeVolume(event: any): void {
    const value = +event.target.value;
    this.volume = value;

    const audioElem = document.getElementById('metroNomeAudioElem') as HTMLAudioElement;
    if (audioElem) {
      audioElem.volume = value / 100;
    }
  }

  playMetronomeSound(): void {
    clearInterval(this.metronomeSoundInterval);

    if (this.isPlaying) {
      const bpm = +this.selectedBPM;
      const interval = (60 / bpm) * 1000;
      const audioElem = document.getElementById('metroNomeAudioElem') as HTMLAudioElement;
      this.metronomeSoundInterval = setInterval(() => {
        audioElem.currentTime = 0;
        audioElem.play();
      }, interval);
    }
  }

  toggleTileViewBtn(): void {
    if (!this.api) {
      return;
    }
    this.api.executeCommand('setTileView', true);
  }

}
